import { render, staticRenderFns } from "./caracteristicas.vue?vue&type=template&id=07f3b277&scoped=true&"
import script from "./caracteristicas.vue?vue&type=script&lang=js&"
export * from "./caracteristicas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f3b277",
  null
  
)

export default component.exports